var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{key:_vm.icon,class:[_vm.$style.root, _vm.disabled && _vm.$style.disabled],attrs:{"data-test":`ICON_${_vm.icon.toUpperCase()}`},domProps:{"innerHTML":_vm._s(_vm.raw)}})
}
var staticRenderFns = []

export { render, staticRenderFns }